module.exports = "<div class=\"page-title my-2\">\r\n    Hone Page\r\n</div>\r\n"